




























import {Component, Vue} from "vue-property-decorator";
import {user} from "@/store/types";
import {MutationList as RootMutations} from "../store/modules/root/mutation-list";
import {MutationList as UserMutations} from "../store/modules/user/mutation-list";
import axios from "axios";
import {MutationList as ModalMutations} from "@/store/modules/modal/mutation-list";

@Component
export default class AddFamilyMembers extends Vue {
    private userNamespace = 'root/';
    private modalNamespace = 'modal/';

    // get relative users list
    get relativeUsers(): user[] {
        return this.$store.getters[`${this.userNamespace}getUserList`];
    }

    removeFamilyMember(id: number) {
        this.$store.commit(`${this.modalNamespace}${ModalMutations.SELECT_LOADING_MODAL}`, 'processing request');
        axios.post('https://dev.palmamedical.lv/api/rest/user/members/delete/', {
            token: this.$store.getters[`${this.userNamespace}getUserToken`],
            id: id
        })
            .then(response => {
                this.$store.commit(`${this.userNamespace}${UserMutations.SET_RELATIVES}`, response.data);
            })
            .catch(e => {
                this.$store.commit(`${this.modalNamespace}${ModalMutations.SELECT_MESSAGING_MODAL}`, {
                    header: 'an error happened',
                    message: e
                });
            });
    }

    // button to edit chosen relative user
    editFamilyMember(user: number) {
        this.$router.push('/member/edit/' + user);
    }
}
